import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec36d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-area" }
const _hoisted_2 = { class: "ceci-area" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "ceci-item" }
const _hoisted_5 = { class: "header-item" }
const _hoisted_6 = { class: "ceci-info" }
const _hoisted_7 = { class: "ceci-list-container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { inject, onBeforeMount, ref, watchEffect } from 'vue'
import { getRes } from '@/api/common'
import { ResConfig } from '@/types'
import { ERR_SUCCESS } from '@/api/config'
import bus from '@/utils/bus'
import ResourceStorage from '@/components/resource/ResourceStorage.vue'
import Pagination from '@/components/common/Pagination.vue'
import { useRoute } from 'vue-router'
import { debounce } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'courseResource',
  setup(__props) {

const dataList = ref<ResConfig[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(12)
const totalSize = ref<number>(0)
const { searchKeyword } = inject('searchKeyword', { searchKeyword: ref('') })
const currentResource = ref<ResConfig | null>(null) // Updated type here

const showResource = (item: ResConfig) => { // Ensure `item` matches `ResConfig`
  currentResource.value = item
}

const router = useRoute()

async function fetchData () {
  try {
    currentResource.value = null
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      title: searchKeyword.value,
      course: router.params.id
    }

    const {
      code,
      result: {
        items: data = [],
        total = 0
      } = {}
    } = await getRes({ params })

    if (code === ERR_SUCCESS && data) {
      dataList.value = data
      totalSize.value = total
      currentResource.value = data[0] || null
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

const debouncedFetchData = debounce(fetchData, 300) // 300ms delay

bus.on('keywordChange', (event) => {
  searchKeyword.value = event as string
  debouncedFetchData()
})

onBeforeMount(() => fetchData())

watchEffect(() => fetchData())


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_el_empty, {
          "image-size": 300,
          description: "暂无数据"
        })
      ], 512), [
        [_vShow, dataList.value.length == 0]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (data, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['ceci-list', { 'active-card': currentResource.value === data }]),
          onClick: ($event: any) => (showResource(data))
        }, [
          _createVNode(_component_el_tag, {
            class: "index-tag",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_text, { truncated: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.title), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_text, { truncated: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.course_name), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ], 10, _hoisted_3))
      }), 128)),
      _createVNode(Pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
        "total-size": totalSize.value
      }, null, 8, ["current-page", "page-size", "total-size"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (currentResource.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(ResourceStorage, { resource: currentResource.value }, null, 8, ["resource"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_empty, {
              "image-size": 300,
              description: "点击左侧资源查看详情"
            })
          ]))
    ])
  ]))
}
}

})